import axios from 'axios';
import dayjs from 'dayjs'; //https://day.js.org/
import Utility from '../helper/Utility';
import Vue from 'vue';
import BlobService from '@/service/BlobService.js';

/**
 * @method connectBzbsGet
 * @method connectBzbsPost
 * @method connectBzbsGetBlob
 * @method getBaseUrl
 */
export default {
    /**
     * Connect Buzzebees GET method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data (optional)
     * @return Promise
     */
    connectBzbsGet: function (url, token, data) {
        var header = {
            'App-Id': Vue.bzbsConfig.client_id,
        };

        if (data == null) {
            data = {};
        }
        // data.device_app_id = this.config().client_id;
        if (token != null) {
            header.Authorization = 'token ' + token;
        }

        return axios({
            method: 'get',
            url: url,
            params: data,
            headers: header,
        });
    },

    /**
     * Connect Buzzebees GET method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data (optional)
     * @param {string} appId
     * @return Promise
     */
     connectBzbsGetWithAppId: function (appId, url, token, data) {
        var header = {
            'App-Id': appId,
        };

        if (data == null) {
            data = {};
        }
        // data.device_app_id = this.config().client_id;
        if (token != null) {
            header.Authorization = 'token ' + token;
        }

        return axios({
            method: 'get',
            url: url,
            params: data,
            headers: header,
        });
    },

    /**
     * Connect Buzzebees POST method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data parameter
     * @return Promise
     */
    connectBzbsPost: function (url, token, data, uploadKey, uploadfile) {
        var header = {
            // 'App-Id': Vue.bzbsConfig.client_id,
        };
        // data.device_app_id = this.config().client_id;
        var form = this.arrToFormData(data);
        if (uploadKey)
            form.append(uploadKey, uploadfile);

        if (token != null) {
            header.Authorization = 'token ' + token;
        }

        return axios({
            method: 'post',
            url: url,
            data: form,
            headers: header,
        });
    },

    /**
     * Connect Buzzebees POST method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data parameter
     * @param {string} appId
     * @return Promise
     */
     connectBzbsPostWithAppId: function (appId, url, token, data, uploadKey, uploadfile) {
        var header = {
            'App-Id': appId,
        };
        // data.device_app_id = this.config().client_id;
        var form = this.arrToFormData(data);
        if (uploadKey)
            form.append(uploadKey, uploadfile);

        if (token != null) {
            header.Authorization = 'token ' + token;
        }

        return axios({
            method: 'post',
            url: url,
            data: form,
            headers: header,
        });
    },

    arrToFormData: function (arr) {
        var form = new FormData();
        for (var i in arr) {
            form.append(i, arr[i]);
        }
        return form;
    },

    /**
     * Connect Buzzebees GET Blob
     * @param {string} url string url
     * @return Promise
     */
    connectBzbsGetBlob: function (url) {
        const timestamp = dayjs().unix();
        url += `?t=${timestamp}`;
        return axios({
            method: 'get',
            url: url,
        });
    },

    getBaseUrl: function () {
        var api = Utility.getParameterByName("api");
        var strUrl = Vue.bzbsConfig.bzbsUrl;
        if (!api){
            return strUrl;
        }
        strUrl = "https://" + api + ".buzzebees.com";
        return strUrl;
    },

    getBlobWeblandingConfig: function (app_id) {
        var blob_path;
        if (app_id) {
            blob_path = "config/weblanding/" + app_id + ".json";
        }
        else {
            blob_path = "config/weblanding/default.json";
        }
        var url = Vue.bzbsConfig.bzbsBlobUrl;
        return BlobService.apiGetConfig(url, blob_path);
    },

    getBlobAppThemeMapping: function () {
        var blob_path = "config/weblanding/app_mapping.json";

        var url = Vue.bzbsConfig.bzbsBlobUrl;
        return BlobService.apiGetConfig(url, blob_path);
    },
}
